import singleInput from '@ui/form/single-input';
import staticTooltip from '@ui/form/static-tooltip';
import submit from '@ui/form/submit';

import '@utils/jquery/input-set-state';

export const init = (params) => {
    singleInput.init(params);
    staticTooltip.init(params);
    submit.init(params);

    params.$document.inputSetState();
};

export default { init };



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/form/index.js